export enum OPERATION_DETAILS_EVENT_TYPE {
  'USER_INPUT' = 'USER_INPUT',
  'SPECIAL_EVENT' = 'SPECIAL_EVENT',
  'WAP_APP_RESPONSE' = 'WAP_APP_RESPONSE'
}
interface WapInputEvent {
  date: string;
  type: OPERATION_DETAILS_EVENT_TYPE.USER_INPUT;
  input: string;
}

interface SpecialEvent {
  date: string;
  type: OPERATION_DETAILS_EVENT_TYPE.SPECIAL_EVENT;
  text: string;
}

interface WapAppResponseEvent {
  date: string;
  type: OPERATION_DETAILS_EVENT_TYPE.WAP_APP_RESPONSE;
  response: string;
}

export type EventItem = WapInputEvent | SpecialEvent | WapAppResponseEvent;

export interface PresentEventsType {
  type: 'PRESENT';
  items: EventItem[];
}

export interface ExpiredEventsType {
  type: 'EXPIRED';
  message: string;
}

export type EventsType = PresentEventsType | ExpiredEventsType;
